import PropTypes from "prop-types";

export default PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.number,
    jobId: PropTypes.number,
    name: PropTypes.string,
    company: PropTypes.string,
    respondedAt: PropTypes.string,
    message: PropTypes.string,
    reviewAgentUrl: PropTypes.string,
    acceptUrl: PropTypes.string,
    rejectUrl: PropTypes.string,
    avatar: PropTypes.string,
    starRatingPercent: PropTypes.number,
    psl: PropTypes.boolean,
  })
);
